export function formatNum(num, { digits = 2, locale = "en-UK"}) {
  if (num) {
    return num.toLocaleString(locale, { minimumFractionDigits: digits, maximumFractionDigits: digits });
  } else {
    return null
  }
}

export function camelToSnake(str) {
  return str.split(/(?=[A-Z])/).join('_').toLowerCase();
}

export function nameOf(obj) {
  console.log("Inside nameOf(), obj ==> ", obj)
  // check to make sure we are getting the value of a proxy object
  const _obj = obj.value ? obj.value : obj

  if (_obj['num']) {
    return _obj.num
  } else {
    return _obj.name
  }
}

export function isStringHTML(text) {
  return /<\/?[a-z][\s\S]*>/i.test(text)
}